'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/definition-list.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _lodash = require('lodash');
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _componentThemes$defi = _themes.componentThemes.definitionList,
  definitionListStyle = _componentThemes$defi.definitionListStyle,
  definitionListTheme = _componentThemes$defi.definitionListTheme;
DefinitionList.propTypes = {
  headers: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    key: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  })])).isRequired,
  data: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])).isRequired,
  offWhite: _propTypes.bool,
  noMargin: _propTypes.bool,
  headerWidth: _propTypes.string
};
DefinitionList.defaultProps = {
  offWhite: false,
  noMargin: false,
  headerWidth: null
};
var definitionListStyles = function definitionListStyles(_ref) {
  var noMargin = _ref.noMargin,
    theme = _ref.theme;
  return _defineProperty({
    borderCollapse: 'seperate',
    borderSpacing: '3px 3px',
    margin: noMargin ? '0 -3px' : undefined
  }, (0, _themes.between)(0, theme.breakpoint_sm), {
    margin: noMargin ? '0' : undefined
  });
};
var DefinitionListWrapper = (0, _glamorous2.default)('dl')(definitionListStyles);
var definitionStyles = function definitionStyles(_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    display: 'table-row'
  }, (0, _themes.between)(0, theme.breakpoint_sm), {
    display: 'flex',
    flexDirection: 'column'
  });
};
var DefinitionWrapper = (0, _glamorous2.default)('div')(definitionStyles);
var sharedDefinitionDescriptionTermStyles = function sharedDefinitionDescriptionTermStyles(_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    padding: '4px ' + theme.space_sm,
    display: 'table-cell'
  }, (0, _themes.between)(0, theme.breakpoint_sm), {
    margin: 0
  });
};
var definitionTermStyles = function definitionTermStyles(_ref7) {
  var _Object$assign;
  var theme = _ref7.theme;
  return Object.assign({}, sharedDefinitionDescriptionTermStyles({
    theme: theme
  }), (_Object$assign = {
    width: '100%'
  }, _defineProperty(_Object$assign, (0, _themes.atLeast)(theme.breakpoint_sm), {
    width: 'auto',
    whiteSpace: 'nowrap',
    textAlign: 'right'
  }), _defineProperty(_Object$assign, 'color', definitionListTheme(theme)[definitionListStyle('definitionColor')]), _defineProperty(_Object$assign, 'backgroundColor', definitionListTheme(theme)[definitionListStyle('definitionBackgroundColor')]), _Object$assign));
};
var DefinitionTerm = (0, _glamorous2.default)('dt')(definitionTermStyles);
var definitionDescriptionStyles = function definitionDescriptionStyles(_ref8) {
  var theme = _ref8.theme,
    offWhite = _ref8.offWhite;
  return Object.assign({}, sharedDefinitionDescriptionTermStyles({
    theme: theme
  }), {
    fontWeight: theme.fontBold,
    width: '100%',
    backgroundColor: offWhite ? definitionListTheme(theme)[definitionListStyle('offWhiteDescriptionBackgroundColor')] : definitionListTheme(theme)[definitionListStyle('descriptionBackgroundColor')]
  });
};
var DefinitionDescription = (0, _glamorous2.default)('dd')(definitionDescriptionStyles);
function DefinitionList(props) {
  var _this = this;
  var headers = props.headers,
    data = props.data,
    noMargin = props.noMargin,
    headerWidth = props.headerWidth,
    offWhite = props.offWhite,
    rest = _objectWithoutProperties(props, ['headers', 'data', 'noMargin', 'headerWidth', 'offWhite']);
  return _react2.default.createElement(DefinitionListWrapper, Object.assign({
    noMargin: noMargin
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80
    },
    __self: this
  }), headers.map(function (header) {
    var key = (0, _lodash.isObject)(header) ? header.key : header;
    return _react2.default.createElement(DefinitionWrapper, {
      key: key,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84
      },
      __self: _this
    }, _react2.default.createElement(DefinitionTerm, {
      minWidth: headerWidth,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85
      },
      __self: _this
    }, (0, _lodash.isObject)(header) ? header.text : header), _react2.default.createElement(DefinitionDescription, {
      offWhite: offWhite,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88
      },
      __self: _this
    }, data[key]));
  }));
}
exports.default = DefinitionList;